// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  IGetNormalOfferPricesRequest,
  TGetNormalOfferPricesModel,
  IMappers,
  TGetNormalOfferPricesResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { INormalOfferPricesResponse } from '../../entities/get_normal_offers_prices/NormalOfferPricesResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetNormalOfferPricesModel(parameters: IGetNormalOfferPricesRequest): TGetNormalOfferPricesModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'mortgage-subsidised-offers',
    pathApi: '/v1/get-normal-offer-prices/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface IGetNormalOfferPricesOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetNormalOfferPricesRequest;
}

export async function fetchGetNormalOfferPrices<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetNormalOfferPricesOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetNormalOfferPricesResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetNormalOfferPricesModel(parameters),
    config,
  )) as FetchResponse<TGetNormalOfferPricesResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as INormalOfferPricesResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetNormalOfferPricesResponse>;
}
